import React from 'react'

export const BellIcon = (props) => (
  <svg xmlns='http://www.w3.org/2000/svg'
    style={props.style}
    className='icon--bell'
    viewBox='-289 381 32 32'
  >
    <path
      d='M-261.1,402.1l-2.3-4.5c-0.1-0.2-0.2-0.3-0.2-0.5c-0.4-1.4-0.5-2.9-0.5-4.2v-0.5c0-5.1-3.9-9.2-8.8-9.2s-8.8,4.1-8.8,9.3 v0.3c0,1.5-0.1,3.1-0.5,4.5c-0.1,0.2-0.1,0.3-0.2,0.5l-2.4,4.4c-0.1,0.3-0.2,0.5-0.2,0.8c0,0.6,0.2,1.3,0.7,1.7 c0.4,0.4,1,0.7,1.6,0.7h5.3c-0.1,0.7-0.1,1.4,0.1,2.2c0.6,1.9,2.4,3.3,4.4,3.3c2.5,0,4.6-2.1,4.6-4.6c0-0.3,0-0.6-0.1-0.9h5.2 c0.6,0,1.2-0.2,1.6-0.7c0.5-0.5,0.7-1.1,0.7-1.7C-261,402.7-261,402.4-261.1,402.1z M-270.1,406.2c0,1.6-1.3,2.9-2.9,2.9 c-1.6,0-2.9-1.3-2.9-2.9c0-0.3,0-0.6,0.1-0.9h5.6C-270.1,405.6-270.1,405.9-270.1,406.2z M-262.9,403.5c-0.1,0.1-0.3,0.2-0.4,0.2 h-5.9h-2.4h-2.9h-2.4h-5.9c-0.1,0-0.3-0.1-0.4-0.2c-0.1-0.1-0.2-0.3-0.2-0.5c0-0.1,0-0.2,0.1-0.3l2.4-4.5c0.1-0.1,0.1-0.3,0.2-0.4 c0.6-1.7,0.7-3.6,0.7-5.2v-0.3c0-4.2,3.2-7.6,7.1-7.6c3.9,0,7.1,3.4,7.1,7.6v0.5c0,1.5,0,3.2,0.6,4.8c0,0.1,0.1,0.3,0.2,0.4 l2.4,4.6c0,0.1,0,0.2,0,0.3C-262.7,403.2-262.7,403.4-262.9,403.5z'
    />
  </svg>
)
